import {
    // @ts-ignore
    IMessageHistoryJson,
} from "../../../../../nodeserver/structs/database.js";
import { extendClass } from "../../messages/helpers.js";
import JSX from "./../../helpers/react.js";





export enum MessageStatusComplaints {
    Add = 0,
    Reject = 1,
    Approved = 2,
    Resotred = 3,
    Argue = 4
}

export function SelfMessageSign(){
    return <span className="white-text">своё&nbsp;</span>;
}



export function NickName(props:{
    id: number,
    nickname: string
}){
    return <a href={`/users/id${props.id}`}>
        <span className="nickname-color">{props.nickname}&nbsp;</span>
    </a>
}



export function Text(props:{
    text:string
}){
    return <div className="text">{props.text}</div>;
}





export function ActionDate(props:{
    date: number
}){
    const localTime: HTMLElement = <local-time data-preposition="true" data-time={props.date} className="action-date"/>;
    return <div className="action-date">{localTime.innerHTML}</div>
}


export function ActionIndicator(props: {
    imgSrc:string,
    actionClass: string
}){
    return <div className="type-indicator-container">
        <div className="type-indicator">
            <img className="svg-action" src={props.imgSrc}/>
            <div
                className={props.actionClass}/>
        </div>
    </div>
}


export function Action(props:{
    nickname:string,
    userId: number,
    ownerNick:string,
    isOnlySignType:boolean
}){
    return(<>
        {!!(props.ownerNick === props.nickname && !props.isOnlySignType) && <SelfMessageSign />}
        <SignType />
        {!!(props.ownerNick !== props.nickname && !props.isOnlySignType) && <NickName id={props.userId} nickname={props.ownerNick}/>}
    </>)
}


function MessageAction(props:{
    el: IMessageHistoryJson
}){
    switch(props.el.change_type){
        case "add":
            return (<span className="green-color">написал&nbsp;</span>);
        case "delete":
            return (<span className="red-color">удаляет&nbsp;</span>);
        case "edit":
            return (<span className="yellow-color">редактирует&nbsp;</span>);
        case "restore":
            return (<span className="green-color">восстановливает&nbsp;</span>);
        default:
            return "";
    }
}

export function ActionStatus(props:{
    el: IMessageHistoryJson | MessageStatusComplaints
}){
    if(typeof props.el === "object"){
        return MessageAction({
            el:props.el
        }) 
    }
    else{
        return ClaimAction({
            status:props.el
        })
    }
}


export function SignType(){
    return <span className="white-text">сообщение&nbsp;</span>;
}


function ClaimAction({status}: { status: MessageStatusComplaints }) {
    switch (status) {
        case MessageStatusComplaints.Reject:
            return <>
                <span className="green-color">отклоняет&nbsp;</span>
                <span>жалобу на&nbsp;</span>
            </>
        case MessageStatusComplaints.Approved:
            return <span className="red-color">удаляет&nbsp;</span>;
        case MessageStatusComplaints.Add:
            return <>
                <span className="red-color">жалуется&nbsp;</span>
                <span>на&nbsp;</span>
            </>;
        case MessageStatusComplaints.Resotred:
            return <>
                <span className="green-color">восстановливает&nbsp;</span>
            </>;
        case MessageStatusComplaints.Argue:
            return (
                <>
                    <span className="red-color">оспаривает&nbsp;</span>
                    <span>отклонение жалобы на&nbsp;</span>
                </>
            )
        default:
            return <></>;
    }
    
}





export function ActionOwnerProfileLink(props:{
    userId: number,
    nickname: string
}){
    return <a href={`/users/id${props.userId}`}>
        <span className="nickname-color nickname"><wbr/>
            {props.nickname}&nbsp;</span>
    </a>
}




export function HistoryContainerElement(
props: {
    firstBlock: HTMLElement[],
    actions: HTMLElement[],
    dataElements: HTMLElement[],
    iterator: number,
    prefix: string,
    className?: string,
    additionalBlocks?: HTMLElement[]
}) {
    const className = props.className  ? props.className + " message" : "message"
    return (<div className={className}
        iterator={`${props.prefix}${props.iterator}`}
        onClick={() => historyElementMessageClickEventHandler(props.iterator, props.prefix)}
    >
        <div className="first-block">
            {...props.firstBlock}
        </div>
        {...props.additionalBlocks ?? <></>}
        <div className="data">
            <div className="action">
                {...props.actions}
            </div>
            {...props.dataElements}
        </div>
    </div>)
}



function historyElementMessageClickEventHandler(iterator: number, prefix: string) {
    const historyElmenent = $(`.actions-message-container .message[iterator="${prefix}${iterator}"]`)

    historyElmenent.toggleClass(extendClass);
}

    